window.newInWaypoints = function newInWaypoints() {

    checkItemImageLoaded();

    checkItemsInView();

    $(window).scroll(function () {

        checkItemsInView();

        var windowTop = Math.max($('body').scrollTop(), $('html').scrollTop()),
            offset = matchesMediaQuery(0, 670) ? 100 : 300;

        $('.newItem').each(function (index) {
            if (windowTop > ($(this).offset().top - offset)) {
                $(this).find('.js_newItemIn').fadeOut('slow');
            }
        });

    });
}

window.checkItemImageLoaded = function checkItemImageLoaded() {

    console.log('is this running');

    $('.itemSingle.loadingItem').each(function (index) {
        var $this = $(this);
        $this.find('.js_searchImage').on('load', function () {
            $this.removeClass('loadingItem').addClass('loadedItem');

            checkItemsInView($this);
        }).each(function () {
            if(this.complete) $(this).trigger('load');
        });
    });
}

window.checkItemsInView = function checkItemsInView() {
    $('.itemSingle.loadedItem').each(function (index) {
        var $this = $(this);

        checkItemInView($this);
    });
}

window.checkItemInView = function checkItemInView($this) {
    var windowTop = Math.max($('body').scrollTop(), $('html').scrollTop()),
        offset = matchesMediaQuery(0, 670) ? 100 : 500;

    if ((windowTop + offset + $(window).height()) > ($this.offset().top) && windowTop < ($this.height() + $this.offset().top + offset)) {

        $this.removeClass('loadedItem');

        var $image = $this.find('.js_searchImage'),
            src = $image.data('image'),
            alt = $image.attr('alt'),
            mobile_slider = $this.find('.js_itemMobileImages'),
            slider_options = {
                lazyLoad: 'ondemand',
                dots: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                nextArrow: '<a class="slick-next"><img src="/sites/petervardy/images/svgs/angle-right-regular.svg" alt="Next Image"/></a>',
                prevArrow: '<a class="slick-prev"><img src="/sites/petervardy/images/svgs/angle-left-regular.svg" alt="Previous Image"/></a>',
                adaptiveHeight: true
            };

        function imageSlider() {
            mobile_slider.slick(slider_options);

            mobile_slider.find('.slick-active img').on('load', function () {
                mobile_slider.addClass('displaySlider');
            }).each(function () {
                if(this.complete) $(this).trigger('load');
            });
        }

        if (src) {

            $image.after('<img src="' + src + '" alt="' + alt + '" class="searchImage" />');

            var next_image = $image.next();

            next_image.on('load', function () {
                next_image.fadeIn(function () {
                    $image.remove();
                    imageSlider();
                });
            }).each(function () {
                if(this.complete) $(this).trigger('load');
            });

        } else {
            imageSlider();
        }
    }
}